// ── VIDEO MODAL FUNCTIONALITY ──
const modal = document.getElementById("roqVideoModal");
const focusableSelectors =
  'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

// Modal close function
function closeModal() {
  if (modal) {
    modal.classList.remove("active");
    document.body.style.overflow = "";
  }
}

// Modal open function
function openModal(videoUrl) {
  if (modal) {
    modal.classList.add("active");
    document.body.style.overflow = "hidden";

    // Update video in modal if videoUrl is provided
    if (videoUrl) {
      const videoModalPh = modal.querySelector(".video-modal-ph");
      if (videoModalPh) {
        videoModalPh.innerHTML = `<video style="width: 100%; height: 100%; object-fit: contain;" controls autoplay>
          <source src="${videoUrl}" type="video/mp4">
          Your browser does not support the video tag.
        </video>`;
        // Explicitly play the video
        const video = videoModalPh.querySelector("video");
        if (video) {
          video.play().catch(err => console.log("Autoplay failed:", err));
        }
      }
    }

    setTimeout(() => {
      const first = modal.querySelector(focusableSelectors);
      if (first) first.focus();
    }, 50);
  }
}

// Open modal button
document.querySelectorAll(".btn-roq-video").forEach((btn) => {
  btn.addEventListener("click", function (e) {
    e.preventDefault();
    const videoUrl = this.getAttribute("data-video-url");
    openModal(videoUrl);
  });
});

// Close modal button
const closeBtn = document.querySelector(".video-modal-close");
if (closeBtn) {
  closeBtn.addEventListener("click", closeModal);
}

// Close modal when clicking overlay
if (modal) {
  modal.addEventListener("click", function (e) {
    if (e.target === this) {
      closeModal();
    }
  });
}

// Escape key + focus trap
document.addEventListener("keydown", function (e) {
  if (e.key === "Escape" && modal && modal.classList.contains("active")) {
    closeModal();
  }
  if (e.key === "Tab" && modal && modal.classList.contains("active")) {
    const focusable = Array.from(modal.querySelectorAll(focusableSelectors));
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }
});

// Handle the Let's get to work button
const workBtn = document.querySelector(".video-modal-footer .btn-sm-dark");
if (workBtn) {
  workBtn.addEventListener("click", closeModal);
}

// ── TOUCH SUPPORT FOR NAV DROPDOWNS ──
document.querySelectorAll(".nav-trigger").forEach((trigger) => {
  trigger.addEventListener("click", function (e) {
    const item = this.closest(".nav-item");
    const isOpen = item.classList.contains("touch-open");
    // Close all
    document
      .querySelectorAll(".nav-item")
      .forEach((i) => i.classList.remove("touch-open"));
    if (!isOpen) {
      item.classList.add("touch-open");
      this.setAttribute("aria-expanded", "true");
    } else {
      this.setAttribute("aria-expanded", "false");
    }
    e.stopPropagation();
  });
});
document.addEventListener("click", function () {
  document.querySelectorAll(".nav-item").forEach((i) => {
    i.classList.remove("touch-open");
    i.querySelector(".nav-trigger")?.setAttribute("aria-expanded", "false");
  });
});

// ── PROOF MOSAIC TESTIMONIAL INTERACTION ──
(function () {
  const defaultQuote =
    "Deadline hit, quality delivered. Easiest order I've ever placed.";
  const defaultAttr = "Customer Name · Role / Company";

  const quoteEl = document.getElementById("testimonial-quote");
  const attrEl = document.getElementById("testimonial-attr");
  const inner = document.getElementById("testimonial-content");

  if (!quoteEl || !attrEl || !inner) return;

  let timeout;

  function swapTestimonial(quote, attr) {
    clearTimeout(timeout);
    inner.classList.add("fade-out");
    timeout = setTimeout(() => {
      quoteEl.textContent = "\u201C" + quote + "\u201D";
      attrEl.textContent = attr;
      inner.classList.remove("fade-out");
      inner.classList.add("fade-in");
      setTimeout(() => inner.classList.remove("fade-in"), 300);
    }, 200);
  }

  function resetTestimonial() {
    clearTimeout(timeout);
    inner.classList.add("fade-out");
    timeout = setTimeout(() => {
      quoteEl.textContent = "\u201C" + defaultQuote + "\u201D";
      attrEl.textContent = defaultAttr;
      inner.classList.remove("fade-out");
      inner.classList.add("fade-in");
      setTimeout(() => inner.classList.remove("fade-in"), 300);
    }, 200);
  }

  document.querySelectorAll(".proof-tile[data-quote]").forEach((tile) => {
    tile.addEventListener("mouseenter", function () {
      swapTestimonial(this.dataset.quote, this.dataset.attr);
    });
    tile.addEventListener("mouseleave", resetTestimonial);
    // Touch support
    tile.addEventListener(
      "touchstart",
      function (e) {
        e.preventDefault();
        swapTestimonial(this.dataset.quote, this.dataset.attr);
      },
      { passive: false },
    );
  });
})();

// ── QUICK START ITEM INTERACTIONS ──
document.querySelectorAll(".qs-item").forEach((item) => {
  item.addEventListener("click", function () {
    document
      .querySelectorAll(".qs-item")
      .forEach((i) => i.classList.remove("active"));
    this.classList.add("active");
  });
});
